import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getSelectedFacets } from 'selectors/algolia2/data'
import {
  getAlgoliaDataFacetsNames,
  getAlgoliaDataFacets,
  getAvailableFacetNameAttributesList,
  getFacetNameAttributes,
  isFacetNameAvailable,
} from 'selectors/algolia2/facets'
import { getBreadcrumbFacets, hasPrintsSelected } from '../selectors/facets'

const mapStateToProps = createStructuredSelector({
  allFacets: getAlgoliaDataFacets,
  algoliaFacets: getAlgoliaDataFacets,
  breadcrumbFacets: getBreadcrumbFacets,
  facetNames: getAlgoliaDataFacetsNames,
  facetNameAvailable: (state, ownProps) => isFacetNameAvailable(ownProps.facetName)(state),
  facetNameAttributes: (state, ownProps) => getFacetNameAttributes(ownProps.facetName)(state),
  facetNameAttributesList: (state, ownProps) =>
    getAvailableFacetNameAttributesList(ownProps.facetName)(state),
  hasPrints: hasPrintsSelected,
  selectedFacets: getSelectedFacets,
})

export type ConnectorProps = {
  algoliaFacets: Record<string, any>
  allFacets: Record<string, any>
  breadcrumbFacets: Array<string>
  facetNameAttributes: Record<string, any>
  facetNameAttributesList: Array<string>
  facetNameAvailable: boolean
  facetNames: Array<string>
  hasPrints: boolean
  selectedFacets: Record<string, any>
}

export default connect(mapStateToProps)
